<template>
  <div class="food-manage">

    <div class="tuolele-main-box">
      <div class="app-container app-margin-bottom20">
        <el-form ref="postForm" class="project_mission_form" label-width="130px" style="width:70%" :model="postForm" :rules="rules">
          <h3 class="wj-title">基础信息</h3>

          <el-form-item label="*问卷名称" prop="name">
            <el-input v-model="postForm.name" placeholder="请输入问卷名称" />
          </el-form-item>
          <el-form-item label="业务类型" prop="type">
            <el-radio-group v-model="postForm.type">
              <el-radio label="1">托管</el-radio>
              <el-radio label="3">班课</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="*问卷说明" prop="remark">
            <el-input v-model="postForm.remark" type="textarea" placeholder="请输入问卷说明" />
            <p>1、默认会增加显示【XX（学员姓名）家长，你好】文案</p>
            <p>2、请填写40个文字以内，否则影响家长端展示</p>
          </el-form-item>
          <el-form-item label="上传图片">
            <el-upload
              class="cover-uploader"
              accept=".jpg, .png"
              :action="qiniuUrl"
              :data="imageToken"
              :show-file-list="false"
              :on-success="(file) => { handleMainImgSuccess(file) }"
              :before-upload="(file) => { beforeImgUpload(file) }"
            >
              <el-button type="primary">上传图片</el-button>
            </el-upload>
            <el-image
              v-if="postForm.img"
              class="main-img"
              :src="postForm.img"
              :preview-src-list="[postForm.img]"
            />
            <el-button v-if="postForm.img" type="danger" @click="postForm.img = ''">删除图片</el-button>
          </el-form-item>
          <el-form-item label="*填写截止时间" prop="time">
            <el-date-picker v-model="postForm.deadline" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" />
          </el-form-item>
          <el-form-item label="*允许匿名" prop="is_anonymity">
            <el-radio-group v-model="postForm.is_anonymity">
              <el-radio label="1">允许</el-radio>
              <el-radio label="2">不允许</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="*奖励优豆" prop="point">
            <el-input-number v-model="postForm.point" :min="-10000" :max="10000" label="描述文字" />
          </el-form-item>

        </el-form>
        <div class="question_list_content">
          <h3 class="wj-title">问卷信息</h3>
          <div v-for="(item,index) in questions" :key="'qu'+index" class="question_title fn-clear">
            <el-form label-width="50px" class="project_mission_form" style="width:80%" label-position="right">
              <el-form-item :label="index+1 + '.'" prop="name">
                <div class="wq_flex">
                  <el-input v-model="questions[index].question_title" :placeholder="fnGetPlachor(questions[index].question_type)" />
                  <div v-if="questions[index].question_type != 3" class="upload-cover">
                    <el-upload
                      class="cover-uploader"
                      accept=".jpg, .png"
                      :action="qiniuUrl"
                      :data="imageToken"
                      :show-file-list="false"
                      :on-success="(file) => { handleQuestionImgSuccess(file, index) }"
                      :before-upload="(file) => { beforeImgUpload(file) }"
                    >
                      <el-button type="primary">上传图片</el-button>
                    </el-upload>
                    <el-image
                      v-if="questions[index].question_img"
                      class="cover"
                      :src="questions[index].question_img"
                      :preview-src-list="[questions[index].question_img]"
                    />
                  </div>
                  <el-button v-if="questions[index].question_img" type="warning" icon="el-icon-delete" circle @click="fnDeleteQuestionImage(index)" />
                  <el-button type="danger" @click="fnDeleteQuestion(index)">删除题目</el-button>
                  <el-button type="success" @click="fnUpQuestion(index)">上移</el-button>
                  <el-button type="success" @click="fnDownQuestion(index)">下移</el-button>
                </div>
              </el-form-item>
              <el-form-item v-for="(sub,subindex) in item.option_extra" :key="'sub'+subindex">
                <div v-if="questions[index].question_type == 1" class="question-single">
                  <div class="wq_flex wq_flex_middle">
                    <el-radio label="" disabled />
                    <p>{{ sub.sign }}</p>
                    <el-input v-model="questions[index].option_extra[subindex].content" placeholder="请输入选项" />
                    <div class="upload-cover">
                      <el-upload
                        class="cover-uploader"
                        accept=".jpg, .png"
                        :action="qiniuUrl"
                        :data="imageToken"
                        :show-file-list="false"
                        :on-success="(file) => { handleOptionImgSuccess(file, index, subindex) }"
                        :before-upload="(file) => { beforeImgUpload(file) }"
                      >
                        <el-button type="primary">上传图片</el-button>
                      </el-upload>
                      <el-image
                        v-if="sub.img"
                        class="cover"
                        :src="sub.img"
                        :preview-src-list="[sub.img]"
                      />
                      <el-button v-if="sub.img" type="warning" style="margin-right: 20px;" icon="el-icon-delete" circle @click="fnDeleteOptionImage(index, subindex)" />
                    </div>
                    <el-button type="danger" @click="fnDeleteSelect(index,subindex)">删除选项</el-button>
                  </div>
                </div>
                <div v-if="questions[index].question_type == 2" class="question-multiple">
                  <div class="wq_flex wq_flex_middle">
                    <el-checkbox label="" disabled />
                    <p>{{ sub.sign }}</p>
                    <el-input v-model="questions[index].option_extra[subindex].content" placeholder="请输入选项" />
                    <div class="upload-cover">
                      <el-upload
                        class="cover-uploader"
                        accept=".jpg, .png"
                        :action="qiniuUrl"
                        :data="imageToken"
                        :show-file-list="false"
                        :on-success="(file) => { handleOptionImgSuccess(file, index, subindex) }"
                        :before-upload="(file) => { beforeImgUpload(file) }"
                      >
                        <el-button type="primary">上传图片</el-button>
                      </el-upload>
                      <el-image
                        v-if="sub.img"
                        class="cover"
                        :src="sub.img"
                        :preview-src-list="[sub.img]"
                      />
                      <el-button v-if="sub.img" type="warning" style="margin-right: 20px;" icon="el-icon-delete" circle @click="fnDeleteOptionImage(index, subindex)" />
                    </div>
                    <el-button type="danger" @click="fnDeleteSelect(index,subindex)">删除选项</el-button>
                  </div>
                </div>
                <div v-if="questions[index].question_type == 3" class="question-remark" />
              </el-form-item>
            </el-form>
            <el-button v-if="questions[index].question_type == 1" type="primary" size="middle" @click="fnAddSelect(index)">添加单选选项</el-button>
            <el-button v-if="questions[index].question_type == 2" type="primary" size="middle" @click="fnAddSelect(index)">添加多选选项</el-button>

          </div>
          <div style="padding-left:50px">
            <el-button type="primary" @click="fnAddMainQuestion(1)">添加单选</el-button>
            <el-button type="primary" @click="fnAddMainQuestion(2)">添加多选</el-button>
            <el-button type="primary" @click="fnAddMainQuestion(3)">添加简答</el-button>
          </div>

        </div>
        <el-button v-if="postForm.status == '0'" type="primary" style="margin-top: 30px;" @click="fnPostQuestion()">保存</el-button>
      </div>

    </div>

  </div>

</template>
<script>

// import Select from '@/components/Select'

import { validateRequire } from '@/utils/validate'
import qiniuUpload from '@/assets/js/upload.js'
import Tool from '@/assets/js/tool.js'

const defaultPostForm = {
  name: '',
  remark: '',
  deadline: '',
  is_anonymity: '2',
  id: '',
  type: '',
  status: '0',
  point: 0,
  img: ''
}

export default {
  name: 'QuestionnaireDetail',
  components: {

  },
  data() {
    return {
      lists: [],
      postForm: Object.assign({}, defaultPostForm),
      signs: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      questionnaire: '',
      questions: [],
      rules: {
        name: [{ validator: validateRequire, trigger: 'manual', message: '标题名称' }],
        remark: [{ validator: validateRequire, trigger: 'manual', message: '描述' }],
        deadline: [{ validator: validateRequire, trigger: 'manual', message: '时间' }],
        is_anonymity: [{ validator: validateRequire, trigger: 'manual', message: '是否匿名' }],
        point: [{ validator: validateRequire, trigger: 'manual', message: '优豆' }]
      },
      imageToken: {
        token: '',
        key: ''
      },
      qiniuUrl: qiniuUpload.qiniuUrl
    }
  },
  created() {
    this.postForm.id = this.$route.query.id || ''
    if (this.postForm.id) {
      this.fnGetDetail()
    }
    this.imgToken()
  },
  methods: {
    async imgToken() {
      const ret = await this.$http.imgToken()
      this.imageToken.token = ret.token
    },
    handleQuestionImgSuccess(ret, index) {
      this.questions[index].question_img = qiniuUpload.imgSpace + ret.key
    },
    handleMainImgSuccess(ret) {
      this.postForm.img = qiniuUpload.imgSpace + ret.key
    },
    handleOptionImgSuccess(ret, index, subIndex) {
      this.questions[index].option_extra[subIndex].img = qiniuUpload.imgSpace + ret.key
    },
    beforeImgUpload(file) {
      const type = file.name.split('.')[1]
      if (type != 'jpg' && type != 'jpeg' && type != 'png') {
        this.$message({
          type: 'warning',
          message: '文件格式不正确'
        })
        return false
      }
      this.imageToken.key = `${new Date().getTime()}${Math.ceil(Math.random() * 10000)}.${type}`
    },
    fnDeleteQuestionImage: function(index) {
      this.questions[index].question_img = ''
    },
    fnDeleteOptionImage: function(index, subIndex) {
      this.questions[index].option_extra[subIndex].question_img = ''
    },
    fnGetDetail: function() {
      this.$http.getQuestionnaireTemplateInfo(this.postForm).then(res => {
        res.data.deadline = res.data.deadline == '0000-00-00 00:00:00' ? '' : res.data.deadline
        this.postForm = Object.assign(this.postForm, res.data)
        this.questions = this.postForm.contentJson
        console.log(this.questions)
      })
    },
    fnAddMainQuestion(type) {
      this.questions.push({
        question_title: '',
        option_extra: [],
        question_type: type,
        question_img: ''
      })
    },
    fnGetPlachor(type) {
      const typeStr = {
        1: '请输入单选标题',
        2: '请输入多选标题',
        3: '请输入简答标题'
      }
      return typeStr[type]
    },
    fnUpQuestion(idx) {
      if (idx == 0) {
        alert('第1个无法上移')
        return
      }
      this.questions = Tool.frontMove(this.questions, idx)
    },
    fnDownQuestion(idx) {
      if (idx == (this.questions.length - 1)) {
        alert('最后一个无法下移')
        return
      }
      this.questions = Tool.backMove(this.questions, idx)
    },
    fnAddSelect: function(index) {
      this.questions[index].option_extra.push({ sign: this.signs[this.questions[index].option_extra.length], content: '', img: '' })
    },
    fnDeleteQuestion: function(index) {
      this.questions.splice(index, 1)
    },
    fnDeleteSelect: function(index, subindex) {
      this.questions[index].option_extra.splice(subindex, 1)
      var self = this
      this.questions[index].option_extra.forEach((ele, child) => {
        ele.sign = self.signs[child]
      })
    },
    fnPostQuestion: function() {
      this.postForm.contentJson = JSON.stringify(this.questions)
      this.$http.improveQuestionnaire(this.postForm).then(res => {
        if (res.code == 200) {
          this.$message.success('操作成功')
          setTimeout(this.$router.push({ path: '/admin/headquarters/QuestionnaireLists' }), 2000)
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .main-img {
    width: 100px;
    margin-top:10px;
  }
  .upload-cover {
    display: flex;
    margin-left: 20px;
    .cover-uploader {
      margin-right: 20px;
      .el-upload {
        cursor: pointer;
        position: relative;
      }
    }
    .cover {
      width: 40px;
      height: 40px;
      margin-right: 20px;
    }
  }
  .wj-title{
    color:#333333;
    margin-bottom:10px;
  }
  .project_mission_form .el-form-item{
    margin-bottom: 10px;
  }
  .wq_flex {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
  }
  .question_list_content .el-radio {
    margin-right:0px!important
  }

  .wq_flex_wrap {
    flex-wrap: wrap;
  }

  .wq_flex_sub {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
  }
  .wq_flex_middle {
    align-items:center
  }
  .question-single .wq_flex,
  .question-multiple .wq_flex   {
    margin-top:10px;
  }
  .question_title>.el-button {
    margin-bottom: 10px;
    margin-left:50px
  }
  .question-single .wq_flex p,
  .question-multiple .wq_flex p  {
    margin-right:10px
  }

  .question-multiple .el-checkbox {
    margin-right:10px;
  }
  .question-single>.wq_flex:first-child,
  .question-multiple>.wq_flex:first-child {
    margin-top:0px!important;
  }

</style>
